import type { Menu } from '@/types'
import { getMenus } from '@/utils/endpoint'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import CateDropdown from '../CateDropdown'
import MenuIcon from '../Icon/MenuIcon'

export const MegaMenu = () => {
  const router = useRouter()
  const t = useTranslations('Header')
  const [showAllCate, setShowAllCate] = useState(false)
  const [megaMenuData, setMegaMenuData] = useState<Menu[]>([])

  const cateDropdown = useMemo(() => {
    return (
      <div
        className={`${
          showAllCate ? 'block ' : 'hidden'
        } absolute left-[1rem] top-12 z-[9999] min-h-[450px] w-fit max-w-[318px] pt-2`}
        id='main-mega-menu-items'
      >
        <CateDropdown
          className='rounded-[8px] bg-white-400 shadow-grey-400 drop-shadow'
          items={megaMenuData}
        />
      </div>
    )
  }, [megaMenuData, showAllCate, router])

  useEffect(() => {
    getMenus().then(res => setMegaMenuData(res || []))
  }, [])

  useEffect(() => {
    const handleStart = () => {
      setShowAllCate(false)
    }
    router.events.on('routeChangeComplete', handleStart)
    return () => {
      router.events.off('routeChangeComplete', handleStart)
    }
  }, [router])

  return (
    <button
      className=' ml-10 flex h-12 items-center gap-3 whitespace-nowrap rounded-full border-none bg-[#FFFFFF1A] pl-5 pr-8 text-sm font-semibold text-white outline-none'
      onMouseEnter={() => setShowAllCate(true)}
      onMouseLeave={() => setShowAllCate(false)}
      onClick={() => setShowAllCate(true)}
    >
      <MenuIcon />
      <span>{t('allCate')}</span>
      {showAllCate && cateDropdown}
    </button>
  )
}
